const crypto = require('crypto');

export function decryptCSharpAes(
  encrypted: string,
  password: string,
  salt: string,
  iterations: number,
  keySize: number,
  initializer: string
): { ReportId: string } | null {
  try {
    const IV_DELIM = '\u0001';
    let iv, ciphertext;

    const parts = encrypted.split(IV_DELIM);
    if (parts.length !== 2) {
      iv = Buffer.from(initializer, 'ascii');
      ciphertext = Buffer.from(encrypted, 'base64');
    } else {
      const [ivB64, cipherB64] = parts;
      if (!ivB64 || !cipherB64) {
        throw new Error('Missing IV or ciphertext');
      }
      iv = Buffer.from(ivB64, 'base64');
      ciphertext = Buffer.from(cipherB64, 'base64');
    }
    const key = crypto.pbkdf2Sync(password, Buffer.from(salt, 'ascii'), iterations, keySize / 8, 'sha1');
    const decipher = crypto.createDecipheriv('aes-' + keySize + '-cbc', key, iv);
    // decipher.setAutoPadding(true);
    let decrypted = decipher.update(ciphertext, undefined, 'utf8');
    decrypted += decipher.final('utf8');
    return JSON.parse(decrypted);
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
}
